/**
 * Hand targets registered by motion groups for their own poses (classic design coordinates, as `POSE_HANDS` in
 * rig/skeleton.ts): a leaf registry, so a new group places its hands without editing the skeleton. Read after the
 * skeleton's own tables (wushu polish, idle keys, `POSE_HANDS`).
 */
export type PoseHands = { A?: [number, number]; B?: [number, number] };

export const EXTRA_HANDS: Record<string, PoseHands> = {};

export function registerPoseHands(hands: Readonly<Record<string, PoseHands>>): void {
  Object.assign(EXTRA_HANDS, hands);
}
